/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";

const TopRightUser = ({ userInfo = {}, onLogoutPress }) => {
  const {
    workerFirstName,
    workerSurname,
    workerDesignation,
    workerDepartment
  } = userInfo;
  return (
    <li className="dropdown notification-list">
      <button
        className="nav-link dropdown-toggle nav-user arrow-none"
        data-toggle="dropdown"
        role="button"
        aria-haspopup="false"
        aria-expanded="false"
        style={{
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.10) 0%, rgba(0,0,0,0.5) 100%), radial-gradient(at top center, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.40) 120%) #989898"
        }}
      >
        <span className="account-user-avatar">
          <img
            src="https://cdn-icons-png.flaticon.com/512/709/709699.png"
            alt="user-image"
            className="rounded-circle"
          />
        </span>
        <span>
          <span className="account-user-name text-white">
            {workerFirstName || ""} {workerSurname || ""}
          </span>
          <span className="account-position  text-white">
            {workerDesignation || ""} / {workerDepartment || ""}
          </span>
        </span>
      </button>
      <div className="dropdown-menu dropdown-menu-right dropdown-menu-animated profile-dropdown ">
        <div className=" dropdown-header noti-title">
          <h6 className="text-overflow m-0">Welcome !</h6>
        </div>
        {workerDesignation !== "SUPER ADMIN" &&
        workerDepartment !== "SUPER ADMIN" ? (
          <Link
            to="/user/change-module"
            className="dropdown-item notify-item"
          >
            <i className="mdi mdi-view-module"></i>
            <span>Change Module</span>
          </Link>
        ) : null}

        <Link
          to="/user/my-profile"
          className="dropdown-item notify-item"
        >
          <i className="mdi mdi-account-circle"></i>
          <span>My Account</span>
        </Link>
        <Link
          to="/user/change-password"
          className="dropdown-item notify-item"
        >
          <i className="mdi mdi-account-settings-variant"></i>
          <span>Settings</span>
        </Link>
        <Link
          className="dropdown-item notify-item"
          onClick={onLogoutPress}
          to="#"
        >
          <i className="mdi mdi-logout"></i>
          <span>Logout</span>
        </Link>
      </div>
    </li>
  );
};

TopRightUser.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onLogoutPress: PropTypes.func.isRequired
};

export default TopRightUser;
